/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import { getJson } from 'session';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import TransactionsContainer from './container/TransactionsContainer';
import OVRSApplicationContainer from '../violator-entries/container/OVRSApplicationContainer';
import AddViolationTicketModal from './modals/AddViolationTicketModal';
import * as actions from './action';
import * as action from '../violator-entries/action';
import ReprintTransmittalModal from './modals/ReprintTransmittalModal';
import ViewTransmittalModal from './modals/ViewTransmittalModal';

function TabContainer({
  match,
  pathName,
  permissions,
  generateTransmittal,
  getOvrsTransactions,
  getViolationsList,
  showTransaction,
  history,
  showTransactionTrafficViolator
}) {
  const setModal = useContext(ModalContext);

  const getType = () => {
    if (
      `${pathName.indexOf('ordinance-violation-receipts/violations/list')}` > -1
    ) {
      return 'VIOLATOR';
    }
    return 'APPLICATION';
  };

  const onGenerateTransmittal = e => {
    e.preventDefault();

    const args = {
      type: getType(),
    };

    generateTransmittal(args, res => {
      setModal({
        isOpen: true,
        content: (
          <ViewTransmittalModal
            transmittalNumber={_.get(res, 'res.data.attributes.transmittal_no')}
          />
        ),
        title: 'Generate Transmittal',
        modalSize: 'modal-xl',
      });
    });

    setTimeout(() => {
      const params = {
        module_type: 'OVRS',
        transaction_type: 'OVR PAYMENT',
      };
      const params2 = {
        q: '',
      };
      if (getType() === 'APPLICATION') {
        getOvrsTransactions(params, response => {
          const id = _.get(response, 'data.0.id');
          history.push(id);
          showTransaction(id);
        });
      }

      if (getType() === 'VIOLATOR') {
        getViolationsList(params2, response => {
          const id = _.get(response, 'data.0.id');
          history.push(id);
          showTransactionTrafficViolator(id);
        });
      }
    }, 2000);
  };

  const handleAddViolation = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <AddViolationTicketModal />,
      title: 'Add Traffic Violation Record',
      modalSize: 'modal-xl',
    });
  };

  const handleReprintTransmittal = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ReprintTransmittalModal />,
      title: 'Reprint Transmittal',
      modalSize: 'modal-sm',
    });
  };

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['VIEW OVRS ENTRIES']) && (
                <li className="nav-item">
                  <Link
                    to="/ordinance-violation-receipts/violations/search"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf(
                        '/ordinance-violation-receipts/violations/search'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    OVRS Violators Entries
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW TRAFFIC VIOLATORS']) && (
                <li className="nav-item">
                  <Link
                    to="/ordinance-violation-receipts/violations/list"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf(
                        '/ordinance-violation-receipts/violations/list'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Traffic Violators (Traffic Enforcers / Admin Users)
                  </Link>
                </li>
              )}
            </ul>
            <div className="d-flex ml-auto mr-3 my-2">
              {Acl(permissions, ['OVRS PRINT TRANSMITTAL']) && (
                <button
                  type="submit"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                  onClick={onGenerateTransmittal}
                >
                  PRINT TRANSMITTAL &nbsp;
                  <i className="fas fa-print" />
                </button>
              )}
              {Acl(permissions, ['OVRS REPRINT TRANSMITTAL']) && (
                <button
                  type="submit"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                  onClick={handleReprintTransmittal}
                >
                  REPRINT TRANSMITTAL &nbsp;
                  <i className="fas fa-print" />
                </button>
              )}
              {Acl(permissions, ['VIEW ADD VIOLATION TICKET']) && (
                <button
                  type="submit"
                  onClick={handleAddViolation}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2"
                >
                  Add Violation Ticket
                </button>
              )}
            </div>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => (
              <Redirect
                to={
                  Acl(permissions, ['VIEW OVRS ENTRIES'])
                    ? `${match.path}/search`
                    : `${match.path}/list`
                }
              />
            )}
          />
          {Acl(permissions, ['VIEW TRAFFIC VIOLATORS']) && (
            <Route
              path={`${match.path}/list`}
              component={TransactionsContainer}
            />
          )}

          {Acl(permissions, ['VIEW OVRS ENTRIES']) && (
            <Route
              path={`${match.path}/search`}
              component={OVRSApplicationContainer}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

TabContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  generateTransmittal: PropTypes.instanceOf(Function).isRequired,
  getOvrsTransactions: PropTypes.instanceOf(Function).isRequired,
  getViolationsList: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showTransactionTrafficViolator: PropTypes.instanceOf(Function).isRequired
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, { ...actions, ...action }),
]);

export default enhance(TabContainer);
